import moment from "moment";

const Utils = {
  toDate(date) {
    return this.formatDate(date, 'YYYY-MM-DD')
  },
  formatDate(date, format) {
    if (!date) return null;
    return moment(date).format(format)
  },
};

export default Utils;